<template>

    <TemplateBasic 
      v-bind:breadcrumb="breadcrumb"
      v-bind:permission="permission"
      v-bind:disable_page="disablePage">
      
      <AppForm 
        v-show="pageShowData"
        ref="modalForm"
        v-bind:formParameter="RULE_PARAM"
        v-bind:permission="permission"
        v-on:form-input="onFormInput" />

      <TemplateFeedback ref="pageFeedback" />

      <button v-on:click="onCancelButtonClick" type="button" class="btn btn-default">
        Cancel
      </button>
      <button v-show="hasAddOrEditPermission()" v-on:click="onSaveButtonClick" type="button" class="btn btn-success">
        Save
      </button>
      <button v-show="hasDeletePermission() && !pageIsAdd" v-on:click="onDeleteButtonClick" type="button" class="btn btn-danger">
        Delete
      </button>

    </TemplateBasic>

</template>

<script>
import TemplateBasic from "@/components/Template/TemplateBasic";
import TemplateButton from "@/components/Template/TemplateButton";
import TemplateFeedback from "@/components/Template/TemplateFeedback";
import AppSearch from "@/components/App/AppSearch";
import AppPaging from "@/components/App/AppPaging";
import AppFilter from "@/components/App/AppFilter";
import AppTable from "@/components/App/AppTable";
import AppFormInputCheckboxGroup from "@/components/App/AppFormInputCheckboxGroup";
import AppAddButton from "@/components/App/AppAddButton";
import AppForm from "@/components/App/AppForm";
import validation from "@/components/Utility/Validation"
import helper from "@/components/Utility/Helper"
import router from '@/router'

var querystring = require('querystring');

const RULE_PARAM = [
  {
    key: 'title',
    text: 'Role',
  },
  {
    key: 'select_all',
    text: 'Check All',
    form_checkbox: true,
    form_default: 0,
  },
];

export default {
  name: "pageRoleForm",
  components: {
    TemplateBasic,
    TemplateButton,
    AppSearch,
    AppPaging,
    AppFilter,
    AppTable,
    AppAddButton,
    AppForm,
    AppFormInputCheckboxGroup,
    TemplateFeedback,
  },
  data () {
    return {
      permission : null,
      breadcrumb : [
        { name: 'Home', url: helper.WEB_URL },
        { name: 'Administration' },
        { name: 'People Management' },
        { name: 'Internal User Role' },
      ],

      RULE_PARAM,

      pageIsAdd: true,
      pageShowData: false,

      disablePage : false,
    }
  },
  mounted() {
    if(!helper.hasViewPermission(this.permission = helper.getPermission(this))) {
      return;
    }
    
    if(RULE_PARAM.length < 3) {
      let temp = {};
      router.routeList.forEach(route => {
        if(!route.parameter || !route.parameter.permission) {
          return;
        }

        if(route.parameter.permission === 'secretadmin') {
          return;
        }

        if(temp[route.parameter.permission]) {
          return;
        }

        if(!temp[route.section]) {
          temp[route.section] = { divider: route.section };
        }

        temp[route.parameter.permission] = route;
      });

      // TODO kw1 rearrange permission sequence and map action to better name?
      for(let permission in temp) {
        let route = temp[permission];

        if(route.divider) {
          RULE_PARAM.push({
            key: 'divider_' + permission,
            form_html: () => `<h3>${route.divider}</h3><hr>`,
          });
          continue;
        }

        let action = route.name.replace(/(&nbsp;|<([^>]+)>)/ig, ' ');

        if(permission === 'bill_management') {
          action = 'Account Summary';
        } else if(permission === 'report') {
          action = 'Report';
        } else if(permission === 'company') {
          action = 'Customer List (Company)';
        } else if(permission === 'personal') {
          action = 'Customer List (Personal)';
        } else if(permission === 'refund_management') {
        } else if(permission === 'passcard_returned') {
          action = 'Passcard Returned';
        } else if(permission === 'passcard_pending_block') {
          action = 'Pending Block Passcard';
        } else if(permission === 'passcard_pending_unblock') {
          action = 'Pending Unblock Passcard';
        } else if(permission === 'passcard_returned_block') {
          action = 'Pending Block Returned Passcard';
        } else if(permission === 'passcard_returned_unblock') {
          action = 'Pending Unblock Returned Passcard';
        } else if(permission === 'parkinglicense_addon_pending') {
          action = 'Pending ' + action;
        } else if(permission === 'parkinglicense_application_pending') {
          action = 'Pending ' + action;
        } else if(permission === 'parkinglicense_pc_pending') {
          action = 'Pending ' + action;
        }

        RULE_PARAM.push({
          // TODO kw1 add wrapper with select all?
          // form_html: () => '<hr>',
          key: action,
          form_component: AppFormInputCheckboxGroup,
          form_checkbox_group: [],
          form_container_attr: {
            'class': 'col-md-4',
          },
        });

        // action += route.parent ? ` (${route.parent})` : '';

        if(route.parameter.permission_action instanceof Array) {
          // custom permission
          route.parameter.permission_action.forEach(j => {
            let actionText = j.action;
            if(actionText.endsWith(' ')) {
              actionText = actionText + action;
            }

            let permissionText = j.permission;
            if(permissionText.startsWith('.')) {
              permissionText = permission + permissionText;
            }

            RULE_PARAM[RULE_PARAM.length - 1].form_checkbox_group.push({
              key: permissionText,
              text: actionText,
              form_checkbox: true,
              form_default: 1,
            });
          });
        } else if(route.parameter.permission_action === 3) {
          // view only permission
          RULE_PARAM[RULE_PARAM.length - 1].form_checkbox_group.push({
            key: route.parameter.permission + '.view',
            text: 'View ' + action,
            form_checkbox: true,
            form_default: 1,
          });
        } else if(route.parameter.permission_action === 5) {
          // view + add permission
          RULE_PARAM[RULE_PARAM.length - 1].form_checkbox_group.push({
            key: route.parameter.permission + '.view',
            text: 'View ' + action,
            form_checkbox: true,
            form_default: 1,
          });
          RULE_PARAM[RULE_PARAM.length - 1].form_checkbox_group.push({
            key: route.parameter.permission + '.add',
            text: 'Add ' + action,
            form_checkbox: true,
            form_default: 1,
          });
        } else if(route.parameter.permission_action === 4) {
          // view + edit permission
          RULE_PARAM[RULE_PARAM.length - 1].form_checkbox_group.push({
            key: route.parameter.permission + '.view',
            text: 'View ' + action,
            form_checkbox: true,
            form_default: 1,
          });
          RULE_PARAM[RULE_PARAM.length - 1].form_checkbox_group.push({
            key: route.parameter.permission + '.edit',
            text: 'Update ' + action,
            form_checkbox: true,
            form_default: 1,
          });
        } else if(route.parameter.permission_action === 2) {
          // view + add + edit permission
          RULE_PARAM[RULE_PARAM.length - 1].form_checkbox_group.push({
            key: route.parameter.permission + '.view',
            text: 'View ' + action,
            form_checkbox: true,
            form_default: 1,
          });
          RULE_PARAM[RULE_PARAM.length - 1].form_checkbox_group.push({
            key: route.parameter.permission + '.add',
            text: 'Add ' + action,
            form_checkbox: true,
            form_default: 1,
          });
          RULE_PARAM[RULE_PARAM.length - 1].form_checkbox_group.push({
            key: route.parameter.permission + '.edit',
            text: 'Update ' + action,
            form_checkbox: true,
            form_default: 1,
          });
        } else {
          // view + add + edit + delete permission
          RULE_PARAM[RULE_PARAM.length - 1].form_checkbox_group.push({
            key: route.parameter.permission + '.view',
            text: 'View ' + action,
            form_checkbox: true,
            form_default: 1,
          });
          RULE_PARAM[RULE_PARAM.length - 1].form_checkbox_group.push({
            key: route.parameter.permission + '.add',
            text: 'Add ' + action,
            form_checkbox: true,
            form_default: 1,
          });
          RULE_PARAM[RULE_PARAM.length - 1].form_checkbox_group.push({
            key: route.parameter.permission + '.edit',
            text: 'Update ' + action,
            form_checkbox: true,
            form_default: 1,
          });
          RULE_PARAM[RULE_PARAM.length - 1].form_checkbox_group.push({
            key: route.parameter.permission + '.remove',
            text: 'Remove ' + action,
            form_checkbox: true,
            form_default: 1,
          });
        }
      };
    }

    this.$nextTick(() => {
      helper.setSidebar('/internalRoleList');
      this.loadData();
    });
  },
  methods: {
    loadData() {
      let roleID = this.$route.query.roleID;
      if(roleID) {
        this.$refs['pageFeedback'].setFeedbackLoading('Loading role data...');
        this.$http
          .get(
            // this.getUrl() + roleID,
            this.getUrl(),
            helper.createAxiosConfig()
          )
          .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
            this.$refs['pageFeedback'].setFeedbackMessage();
            // this.pageRole = response.data[0];

            this.pageRoleList = response.data;
            this.pageRole = response.data.find(k => helper.compareID(k.id, roleID));
            this.pageRole.rules = JSON.parse(this.pageRole.rules);
            this.pageRole.rules['id'] = this.pageRole['id'];
            this.pageRole.rules['title'] = this.pageRole['title'];
            this.pageRole.rules['select_all'] = 0;
            this.$refs['modalForm'].setForm(this.pageIsAdd = false, this.pageRole.rules);
            this.pageShowData = true;
          })
          .catch(error => {
            this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', 'role data'));
          })
      } else {
        this.$refs['modalForm'].setForm(this.pageIsAdd = true);
        this.pageShowData = true;
      }
    },

    getUrl() {
      return helper.SERVER_URL + '/api2/roles/';
    },

    onCancelButtonClick() {
      helper.redirect(helper.WEB_URL + '/internalRoleList');
    },
    onSaveButtonClick() {
      if(this.$refs['modalForm'].formIsAdd) {
        this.onModalAddDataClick(this.$refs['modalForm'].formData);
      } else {
        this.onModalEditDataClick(this.$refs['modalForm'].formData);
      }
    },
    onDeleteButtonClick() {
      this.onModalDeleteDataClick(this.$refs['modalForm'].formData);
    },

    onModalAddDataClick(selectedData) {
      let tempData = {};
      tempData['title'] = (selectedData['title'] || '').trim();

      if(!tempData['title']) {
        this.$refs['modalForm'].$refs['jt-form-element-title'][0].setInputError('Role name cannot be empty');
        this.$refs['pageFeedback'].setFeedbackError('Role name cannot be empty');
        return
      }

      this.$refs['modalForm'].$refs['jt-form-element-title'][0].setInputError('');
      this.$refs['pageFeedback'].setFeedbackError('');

      let rules = {};
      for(let index in selectedData) {
        if(selectedData[index]) {
          rules[index] = 1;
        }
      }
      tempData['rules'] = JSON.stringify(rules);

      this.$refs['pageFeedback'].setFeedbackLoading('Adding ' + selectedData.title);
      this.$http
        .post(
          this.getUrl(),
          querystring.stringify(tempData),
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          // this.pageRoleList.find(k => helper.compareID(k.id, selectedData.id))['rules'] = tempData['rules'];

          this.upsertDataComplete('Successfully added ' + selectedData.title);
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'adding', 'data'));
        })
    },
    onModalEditDataClick(selectedData) {
      let tempData = {};
      tempData['title'] = (selectedData['title'] || '').trim();

      if(!tempData['title']) {
        this.$refs['modalForm'].$refs['jt-form-element-title'][0].setInputError('Role name cannot be empty');
        this.$refs['pageFeedback'].setFeedbackError('Role name cannot be empty');
        return
      }

      this.$refs['modalForm'].$refs['jt-form-element-title'][0].setInputError('');
      this.$refs['pageFeedback'].setFeedbackError('');
      
      let rules = {};
      for(let index in selectedData) {
        if(selectedData[index]) {
          rules[index] = 1;
        }
      }
      tempData['rules'] = JSON.stringify(rules);

      this.$refs['pageFeedback'].setFeedbackLoading('Updating ' + selectedData.title);
      this.$http
        .put(
          this.getUrl() + selectedData.id,
          querystring.stringify(tempData),
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          // this.pageRoleList.find(k => helper.compareID(k.id, selectedData.id))['rules'] = tempData['rules'];
          this.upsertDataComplete('Successfully update ' + selectedData.title);
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'updating', 'data'));
        })
    },
    onModalDeleteDataClick(selectedData) {
      this.$refs['pageFeedback'].setFeedbackLoading('Deleting ' + selectedData.title);
      this.$http
        .delete(
          this.getUrl() + selectedData.id,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          // for(let userIndex in this.pageRole) {
          //   if(selectedData['id'] === this.pageRole[userIndex]['id']) {
          //     this.pageRole.splice(userIndex, 1);
          //     break;
          //   }
          // }

          this.upsertDataComplete('Successfully delete ' + selectedData.title);
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'deleting', 'data'));
        })
    },
    upsertDataComplete(message) {
      this.$refs['pageFeedback'].setFeedbackMessage('Operation success');
      helper.redirect(helper.WEB_URL + '/internalRoleList');
    },
    
    onFormInput(formData, formParameter, input) {
      if(formParameter.key === 'select_all') {
        var checked = formData[formParameter.key];
        this.RULE_PARAM.forEach(k => {
          if(k.form_checkbox) {
            formData[k.key] = checked;
          } else if(k.form_checkbox_group) {
            k.form_checkbox_group.forEach(j => {
              formData[j.key] = checked;
            });
            
            this.$nextTick(() => {
              this.$refs['modalForm'].$refs['jt-form-element-' + k.key][0].$refs['input'].$forceUpdate();
            });
          }
        });
      }
    },

    hasAddOrEditPermission() {
      if(this.pageIsAdd) {
        return helper.hasAddPermission(this.permission);
      } else {
        return helper.hasEditPermission(this.permission);
      }
    },
    hasDeletePermission() {
      return helper.hasDeletePermission(this.permission);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Page/Admin/PageRoleForm.vue